export const createLikieeMutation = /* GraphQL */ `
  mutation CreateLikiee($input: CreateLikieeInput!, $condition: ModelLikieeConditionInput) {
    createLikiee(input: $input, condition: $condition) {
      id
      isEnhancingInProgress
      isVisualMatchesInProgress
      likieeItemId
      likieeSourceId
      priceAlertId
      owner
      sortHash
      status
      url
      imageURL
      thumbnailURLs
      images
      breadcrumbs
      description
      name
      canonicalUrl
      createdAt
      price
      originalPrice
      priceTrend
      priceRange {
        min
        max
        currency
        count
      }
      currency
      regularPrice
      availability
      mpn
      aggregateRating
      descriptionHtml
      supportedLocales
      additionalProperty
      sku
      upc
      gtin
      color
      brand
      model
      probability
      updatedAt
      locale
    }
  }
`;

export const updateLikieeMutation = /* GraphQL */ `
  mutation UpdateLikiee($input: UpdateLikieeInput!, $condition: ModelLikieeConditionInput) {
    updateLikiee(input: $input, condition: $condition) {
      id
      isEnhancingInProgress
      isVisualMatchesInProgress
      item {
        id
        url
        images
        title
        description
        source {
          id
          url
          name
          faviconURL
          createdAt
          updatedAt
        }
        size
        sku
        upc
        gtin
        color
        brand
        model
        itemSourceId
        canonicalUrl
        additionalProperty
        aggregateRating
        descriptionHtml
        mpn
        breadcrumbs
        mainImage
        probability
        supportedLocales
        createdAt
        updatedAt
      }
      owner
      user {
        id
        name
        email
        gender
        createdAt
        updatedAt
        owner
      }
      projects {
        items {
          id
          name
          owner
          visibility
          visibilityGroup
          itemsCount
          icon
          createdAt
          updatedAt
        }
        nextToken
      }
      source {
        id
        url
        name
        faviconURL
        createdAt
        updatedAt
      }
      thumbnailURLs
      images
      status
      url
      affiliateURL
      imageURL
      name
      currency
      normalizedPrice
      relatedItems {
        items {
          id
          url
          images
          title
          currency
          name
          normalizedPrice
          probability
          updatedAt
          locale
        }
        nextToken
      }
      availability
      dateFirstAvailable
      dateLastPriceChange
      lastKnownPrice
      lowestRecordedPrice
      color
      brand
      model
      size
      sku
      upc
      gtin
      probability
      updatedAt
      locale
      createdAt
    }
  }
`;

export const deleteLikieeMutation = /* GraphQL */ `
  mutation DeleteLikiee($input: DeleteLikieeInput!, $condition: ModelLikieeConditionInput) {
    deleteLikiee(input: $input, condition: $condition) {
      id
    }
  }
`;

export const addLikieeFrom = /* GraphQL */ `
  mutation addLikieeFrom($id: ID!) {
    addLikieeFrom(likieeID: $id) {
      id
      name
      url
      images
      imageURL
      currency
      color
      availability
      brand
      price
      originalPrice
      priceTrend
      priceRange {
        min
        max
        currency
        count
      }
    }
  }
`;

export const createPriceAlert = /* GraphQL */ `
  mutation createPriceAlert($input: CreatePriceAlertInput!) {
    createPriceAlert(input: $input) {
      alertPriceMin
      alertWhenGetsCheaper
      checkInterval
      createdAt
      id
      originalPrice
      likieeId
    }
  }
`;

export const updatePriceAlert = /* GraphQL */ `
  mutation updatePriceAlert($input: UpdatePriceAlertInput!) {
    updatePriceAlert(input: $input) {
      alertPriceMin
      alertWhenGetsCheaper
      checkInterval
      createdAt
      id
      originalPrice
      likieeId
    }
  }
`;

export const deletePriceAlert = /* GraphQL */ `
  mutation deletePriceAlert($input: DeletePriceAlertInput!) {
    deletePriceAlert(input: $input) {
      id
    }
  }
`;

export const generateAISummary = /* GraphQL */ `
  mutation GenerateAISummary($likieeId: ID!) {
    generateAISummary(likieeId: $likieeId) {
      error
      success
    }
  }
`;

export const updateVisualMatches = /* GraphQL */ `
  mutation UpdateVisualMatches($likieeId: ID!) {
    updateVisualMatches(likieeId: $likieeId) {
      error
      success
    }
  }
`;
